import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';
import Cookies from "js-cookie";
import {SERVER_BASE_URL} from "../Constants";

const RegisterCompetition = () => {
    const [competitions, setCompetitions] = useState([]);
    const [selectedCompetition, setSelectedCompetition] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCompetitions = async () => {
            try {
                const token =  Cookies.get("token");
                const response = await axios.get(SERVER_BASE_URL + 'api/competitions/competitions-not-registered-in', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                console.log(response);
                setCompetitions(response.data);
            } catch (err) {
                setError('Failed to load competitions');
            }
        };

        fetchCompetitions();
    }, []);

    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            const token =  Cookies.get("token");
            await axios.post(SERVER_BASE_URL + 'api/competitions/register/' + selectedCompetition, {
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            navigate('/profile');
        } catch (err) {
            setError('Failed to register for competition');
        }
    };

    return (
        <Container className="mt-4">
            <Card className="p-4">
                <h2>Register for Competition</h2>
                {error && <Alert variant="danger">{error}</Alert>}
                {competitions.length === 0 ? (
                    <>
                        <Alert variant="info">No competitions available to register for.</Alert>
                        <Button variant="secondary" onClick={() => navigate('/profile')}>Back to Profile</Button>
                    </>
                ) : (
                    <Form onSubmit={handleRegister}>
                        <Form.Group controlId="competitionSelect" className="mb-3">
                            <Form.Label>Select Competition</Form.Label>
                            <Form.Select
                                value={selectedCompetition}
                                onChange={(e) => setSelectedCompetition(e.target.value)}
                                required
                            >
                                <option value="">Choose...</option>
                                {competitions.map(comp => (
                                    <option key={comp.competition_id} value={comp.competition_id}>
                                        {comp.competition_name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Button variant="primary" type="submit">Register</Button>
                    </Form>
                )}
            </Card>
        </Container>
    );
};

export default RegisterCompetition;
